import { render, staticRenderFns } from "./QuotationNotesModal.vue?vue&type=template&id=53e76d2c&scoped=true&"
import script from "./QuotationNotesModal.vue?vue&type=script&lang=js&"
export * from "./QuotationNotesModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53e76d2c",
  null
  
)

export default component.exports